import SocialButtonTestContainer from './SocialButtonTest.container';
import SocialButtonTest from './SocialButtonTest';
export default SocialButtonTestContainer(SocialButtonTest);
